import { Checkbox, Input } from 'antd';
import ErrorHandler from 'common/error/components/error-handler';
import SidePanel from 'common/side-panel/side-panel';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Button, Div, Flex } from 'ui';
import { sortParamToCOPSModel } from 'utils/helpers';
import { withRouter } from 'utils/withRouter';

export const Divider = styled(Div)`
  border-bottom: 1px solid ${p => p.theme.colors.border};
  margin: 0.5rem 0;
`;

const Buttons = styled(Flex)`
  > :first-child {
    margin-right: 20px;
  }
`;

const StyledButton = styled(Button)`
  text-transform: uppercase;
`;

const StyledTitle = styled.p`
  margin: 20px 0;
  font-size: 16px;
`;


const StyledDiv = styled.div`
  margin-left: 20px;
`;

const StyledDescription = styled.span`
  font-size: 16px;
`;

const StyledSubdescription = styled.p`
  color: ${p => p.theme.colors.themeSecondary};
  font-size: 12px;
`;

const StyledInput = styled(Input)`
  width: 60%;
`;

const StyledInputContainer = styled.div`
  margin: 30px 0;
`;

const StyledLabel = styled.p`
  width: 100%;
  font-size: 12px;
`;

const StyledCheckboxContainer = styled.div`
  label {
    width: 100%;
  }

  .ant-checkbox-inner {
    width: 20px;
    height: 20px;
  }
  margin-bottom: 50px;
`;

const CreateView = ({
  intl,
  history,
  location,
  id,
  filters,
  sort,
  createView,
  range,
  isSaving,
  error,
  isPlanningBoard = false,
  isGantt = false,
  saveSuccess,
  expandOption,
  defaultExpanded,
}) => {
  const [isDefault, setIsDefault] = useState(false);
  const [templateName, setTemplateName] = useState('');

  const cancel = () => {
    // find /create-views or /create-gantt-views
    const regex = /\/create(-gantt)?-view/;
    if (regex.test(location.pathname)) {
      const goBackPath = location.pathname.replace(regex, '');

      history.replace(goBackPath);
    }
  };

  useEffect(() => {
    if (saveSuccess) {
      cancel();
    }
  }, [saveSuccess]);


  const saveView = () => {
    let view = {
      id,
      templateName,
      filterData: filters,
      sorting: sortParamToCOPSModel(sort),
      viewRange: range?.id,
      isDefault,
      columnInfo: JSON.parse(localStorage.getItem('columnParams')),
      childColumnInfo: JSON.parse(localStorage.getItem('childColumnParams')),
    };
    if (expandOption) {
      view = {
        ...view,
        isExpanded: defaultExpanded,
      };
    }
    createView(view);
  };

  return (
    <SidePanel
      width={'40%'}
      title={isPlanningBoard ?
        intl.formatMessage(
          {
            id:
              'planningBoard.CREATE_VIEW_TITLE',
          },
          {
            type: isGantt ?
              intl.formatMessage({ id: 'planningBoard.GANTT' }) :
              intl.formatMessage({ id: 'planningBoard.WORKLIST' }),
          },
        ) :
        intl.formatMessage(
          {
            id: 'worklist.filters.CREATE_VIEW_TITLE',
          },
        )
      }
      onPanelClose={cancel}
    >
      <ErrorHandler type='notification' error={error} />
      <StyledDiv>
        <StyledTitle><FormattedMessage id='worklist.filters.SAVE_INSTRUCTIONS' /></StyledTitle>
        <StyledInputContainer>
          <StyledLabel><FormattedMessage id='worklist.filters.TITLE_LABEL' /></StyledLabel>
          <StyledInput
            placeholder={intl.formatMessage({
              id: 'worklist.filters.SAVE_PLACEHOLDER',
            })}
            onChange={e => setTemplateName(e.target.value)}
            value={templateName}
            disabled={isSaving}
          />
        </StyledInputContainer>
        <StyledCheckboxContainer>
          <Checkbox
            onChange={() => setIsDefault(!isDefault)}
            disabled={isSaving}
          >
            <StyledDescription>
              <FormattedMessage id='worklist.filters.DEFAULT_VIEW' />
            </StyledDescription>
            <StyledSubdescription>
              {`(${intl.formatMessage({ id: 'worklist.filters.AUTO_OPEN' })})`}
            </StyledSubdescription>
          </Checkbox>
        </StyledCheckboxContainer>
        <Buttons>
          <StyledButton onClick={cancel}>
            <FormattedMessage id='worklist.filters.CANCEL' />
          </StyledButton>
          <StyledButton
            type='secondary'
            onClick={saveView}
            disabled={!templateName}
            loading={isSaving}
          >
            <FormattedMessage id='worklist.filters.SAVE_VIEW_BUTTON' />
          </StyledButton>
        </Buttons>
      </StyledDiv>
    </SidePanel>
  );
};

CreateView.propTypes = {
  intl: PropTypes.object,
  id: PropTypes.string,
  filters: PropTypes.string,
  sort: PropTypes.string,
  history: PropTypes.object,
  location: PropTypes.object,
  createView: PropTypes.func,
  isSaving: PropTypes.bool,
  error: PropTypes.object,
  isPlanningBoard: PropTypes.bool,
  isGantt: PropTypes.bool,
  saveSuccess: PropTypes.bool,
  range: PropTypes.string,
  expandOption: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
};

export default withRouter(injectIntl(CreateView));
